export default {
   // Global
   tmpBackgroundColor: '#fff',
   tmpAppInnerPaddingHorizontal: '20px[a-b] 40px[c] 30px[d] 40px[e-f]', // Protoype
   tmpAppOuterPaddingHorizontal: '20px[a-b] 40px[c] 40px[d] 0px[e-f]', // Protoype padding
   tmpGlobalLayout: 'header',
   headerMainMenuTextSize: '2[a-d] 2.5[e-f]',
   headerMainMenuActionBlockTextSize: '1.5',
   layoutContentFillMode: 'fixed',
   tmpHeaderHeight: '60px[a-b] 75px[c-d] 90px[e-f]',
   tmpHeadingBlockHeight: '90px',
   tmpTitleXlLetterSpacing: '-0.5px[a-d] -0.75px[e-f]',
   tmpTitleXlLineHeight: '120%[a-d] 120%[e-f]',
   tmpTitleXlSize: '9[a-b] 10[c-d] 10[e-f]',
   tmpTitleLgSize: '7[a-b] 8[c-d] 9[e-f]',
   tmpTitleMdSize: '6',
   // Button
   tmpPrimaryButtonTextSize: '2[a-d] 2[e-f]',
   tmpSecondaryButtonTextSize: '1.5[a-d] 2[e-f]',
   tmpPrimaryButtonHeight: '35px[a-d] 38px[e] 40px[f]',
   tmpSecondaryButtonHeight: '35px[a-d] 38px[e] 40px[f]',
   // Spacing
   tmpSpacing: '25px[a-d] 30px[e] 40px[f]',
   tmpSpacingTop: '25px[a-b] 35px[c-f]',
   // Viewport Constants
   tmpViewportHeight: `
      calc(100vh - 60px)[a-b]
      calc(100vh - 75px)[c-d]
      calc(100vh - 90px)[e-f]
   `,
   tmpContentFixedAreaHeight: `
      calc(100vh - 60px)[a-b]
      calc(100vh - 75px)[c-d]
      calc(100vh - 90px)[e-f]
   `,
   viewportMarginTop: '60px[a-b] 75px[c-d] 90px[e-f]',
   tmpViewportPadding: '20px[a] 20px[b] 40px[c] 40px[d] calc(50vw - 750px + 150px)[e] calc(50vw - 750px + 150px)[f]',
   tmpViewportPaddingA: '20px',
   tmpViewportPaddingB: '20px',
   tmpViewportPaddingC: '40px',
   tmpViewportPaddingD: '40px',
   tmpViewportPaddingE: 'calc(50vw - 750px + 150px)',
   tmpViewportPaddingF: 'calc(50vw - 750px + 150px)'
}
